import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  startTime: null,
};

const timerSlice = createSlice({
  name: "timer",
  initialState,
  reducers: {
    startTimer: (state) => {
      state.startTime = Date.now(); // Mutating state (allowed in Immer)
    },
    stopTimer: (state) => {
      state.startTime = null; // Mutating state (allowed in Immer)
    },
    resetTimer: () => initialState, // Returning a new state (correct way)
  },
});

export const { startTimer, stopTimer, resetTimer } = timerSlice.actions;
export default timerSlice.reducer;
